import { push } from 'connected-react-router';
import { connect } from 'react-redux';

const DefaultMasterPage = (props) => <>{props.children}</>;
const mapStateToProps = ({}) => ({});
const mapDispatchToProps = {
  push,
};
export default connect(mapStateToProps, mapDispatchToProps)(DefaultMasterPage);
